import { lighten } from '@material-ui/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const COLORS = {
  primary: '#0A4DF2',
  primaryLight: lighten('#0A4DF2', 0.3),
  secondary: '#A51760',
  secondaryLight: lighten('#A51760', 0.3),
  action: '#18a90f',
  actionLight: lighten('#18a90f', 0.3),
  download: '#333333',
  downloadLight: lighten('#333333', 0.3),
  // Errors/Info
  error: '#F00',
  warning: '#e84004',
  // background
  darkgrey: '#333333',
  mediumgrey: '#666565',
  background: '#eaeff1',
  toolbarBackground: '#f6f5f4',
  white: '#FFF',
  facebookBlue: '#4267B2',
} as const;

export type ColorName = keyof typeof COLORS;
